<template>
  <div class="block">
    <form class= "form-horizontal form-bordered">
			<div class="alert alert-danger" style="visibility:hidden;" id="errorMessage" role="alert">
  Surgio un error, revisa el formulario e intentalo de nuevo
	</div>
		<div class="form-group">
			<label for="inputClientCode" class='col-md-3 control-label'>Código*</label>
			<div class="col-md-9">
				<input v-model="client.code" id="inputClientCode" class='form-control' required/>
				<span class="help-block">Ingrese el código del cliente</span>
			</div>
		</div>
		<div class="form-group">
			<label for="inputClientName" class='col-md-3 control-label' required>Nombre*</label>
			<div class="col-md-9">
				<input v-model="client.name" id="inputClientName" class='form-control'/>
				<span class="help-block">Ingrese el nombre para identificar a este cliente</span>
			</div>
		</div>
		<div class="form-group">
	    <label class='col-md-3 control-label'>Ciudad*</label>
	      <div class="col-md-9">
					<AutocompleteLocal :model.sync="client.city_id" :items="citiesFromController"/>
	        <span class="help-block">Seleccione una ciudad para el proceso</span>
	      </div>
	  </div>
				<div class="form-group">
	    	<label class='col-md-3 control-label'>Estado Cliente*</label>
	      <div class="col-md-9">
					<select class="form-control" name="" v-model="client.billing_mode" id="">
						<option v-for="status in statusClient" :key="status.id" :value="status.id">{{status.name}}</option>
					</select>
	        <span class="help-block">Seleccione un estado para el proceso</span>
	      </div>
	  </div>

		<div class="form-group">
			<label class='col-md-3 control-label'>Nit</label>
			<div class="col-md-9">
				<input v-model="client.nit" id="inputClientNit" class='form-control'>
				<span class="help-block">Ingrese el NIT o identificación</span>
			</div>
		</div>
		<div class="form-group">
			<label class='col-md-3 control-label'>Email</label>
			<div class="col-md-9">
				<input v-model="client.email" type="email" class='form-control'/>
				<span class="help-block">Ingrese un Email</span>
			</div>

		</div>
		<div class="form-group">
			<label for="inputClientTelephone" class='col-md-3 control-label'>Teléfono</label>
			<div class="col-md-9">
				<input v-model="client.telephone" id="inputClientTelephone" class='form-control'>
				<span class="help-block">Ingrese un teléfono</span>
			</div>

		</div>
		<div class="form-group">
			<label for="inputClientCelular" class='col-md-3 control-label'>Celular</label>
			<div class="col-md-9">
				<input v-model="client.cellphone" id="inputClientCelular" class= 'form-control'>
				<span class="help-block">Ingrese un celular</span>
			</div>
		</div>
		<div class="form-group">
			<label for="inputAdministrativeName" class= 'col-md-3 control-label'>Nombre administrador</label>
			<div class="col-md-9">
				<input v-model="client.manager_name" id="inputAdministrativeName" class= 'form-control'>
				<span class="help-block">Ingrese el nombre del administrador</span>
			</div>
		</div>
		<div class="form-group">
			<label class= 'col-md-3 control-label'>Logo Cliente</label>
			<div class="col-md-9">
				<input @change="changeImage" type="file" class= 'form-control'>
				<span class="help-block">Ingrese el logo del cliente
				</span>
			</div>
		</div>

		<div class="form-group">
			<label for="checkDataCredito" class= 'col-md-3 control-label'>Requiere datacredito</label>
			<div class="col-md-9">
				<input v-model="client.credit_validation" type="checkbox" id="checkDataCredito" class= 'checkbox'/> <br/>
				<span class="help-block">Marque si el cliente solicitó verificacion en datacredito</span>
			</div>
		</div>

		<div class="form-group">
			<label for="checkPrefactura" class="col-md-3 control-label">Prefactura</label>
			<div class="col-md-9">
				<input v-model="client.pre_invoice" type="checkbox" id="checkPrefactura" class="checkbox"/>
				<span class="help-block">Marque si el cliente utiliza prefactura</span>
			</div>
		</div>

		<div class="form-group">
			<label for="inputCierreFacturacion" class="col-md-3 control-label">Cierre de facturación (día del mes)</label>
			<div class="col-md-9">
				<input
					v-model.number="client.billing_cutoff_day"
					id="inputCierreFacturacion"
					type="number"
					class="form-control"
					min="1"
					max="31"
					placeholder="Día del mes para cierre de facturación"
				/>
				<span class="help-block">Día del mes para cierre de facturación</span>
				<span v-if="validationErrors.billing_cutoff_day" class="text-danger">{{ validationErrors.billing_cutoff_day }}</span>
			</div>
		</div>

		<div class="form-group">
			<label for="selectPaymentMethod" class="col-md-3 control-label">Forma de pago</label>
			<div class="col-md-9">
				<select v-model="client.payment_method" id="selectPaymentMethod" class="form-control">
					<option :value="null">Seleccione una opción</option>
					<option value="credit">Crédito</option>
					<option value="cash">Contado</option>
				</select>
				<span class="help-block">Seleccione la forma de pago del cliente</span>
			</div>
		</div>

		<div class="form-group">
			<label for="inputNoveltiesRegistration" class="col-md-3 control-label">Registro de novedades</label>
			<div class="col-md-9">
				<input
					v-model="client.novelties_registration"
					id="inputNoveltiesRegistration"
					type="text"
					class="form-control"
				/>
				<span class="help-block">Ingrese el registro de novedades del cliente</span>
			</div>
		</div>

		<div class="form-group">
			<label class= 'col-md-3 control-label' for="textObservations">Observaciones</label>
			<div class="col-md-9">
				<textarea v-model="client.observations" id="textObservations" class= 'form-control' />
				<span class="help-block">Ingrese las observaciones del cliente</span>
			</div>
		</div>

		<div class="form-group form-actions">
			<div class="col-md-9 col-md-offset-3">
				<input type="button" @click="createClient" style="background-color:#aad178;" data-disable-with="Confirmar" value="Confirmar"/>
			</div>
		</div>
  </form>
  </div>
</template>

<script>
import axios from 'axios'
import VueSelect from 'vue-select'
import AutocompleteLocal from '../../../own/autocomplete-local'
import 'vue-select/dist/vue-select.css';
export default {
	name: 'form-clients',
	props: ['cities'],
	data () {
		return {
			token: '',
			client: {
				pre_invoice: false,
				billing_cutoff_day: null,
				payment_method: null,
				novelties_registration: null
			},
			statusClient: [
				{ id: 0, name: 'Procesos Normales' },
				{ id: 1, name: 'Demo' },
				{ id: 2, name: 'Proceso de Prueba' }
			],
			city_id: null,
			validationErrors: {}
		}
	},
	methods: {
		getCities() {
			let path = '/api/v1/cities'
			axios.defaults.headers['token'] = this.token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

			axios.get(path).then(res=>{
				console.log(res)
			})
		},
		validateBillingCutoffDay() {
			this.validationErrors = {}
			const value = this.client.billing_cutoff_day
			if (value !== null && value !== undefined && value !== '') {
				const num = Number(value)
				if (Number.isNaN(num) || num < 1 || num > 31) {
					this.validationErrors.billing_cutoff_day = 'El cierre de facturación debe ser un valor entre 1 y 31.'
					return false
				}
			}
			return true
		},
		createClient() {
			if (!this.validateBillingCutoffDay()) {
				return
			}
			const payload = { client: { ...this.client } }
			if (payload.client.billing_cutoff_day === null || payload.client.billing_cutoff_day === '') {
				payload.client.billing_cutoff_day = null
			}
			const path = '/clients'
			axios.defaults.headers['x-csrf-token'] = this.token
			axios.defaults.headers.common['Accept'] = 'application/json'
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
			axios.post(path, payload).then(res => {
				if (res.status === 201) {
					localStorage.setItem('created', true)
					window.location.replace('/clients/' + res.data.id)
				}
			}).catch(() => {
				const errorMessage = document.getElementById('errorMessage')
				errorMessage.style.visibility = 'visible'
				errorMessage.scrollIntoView(true)
			})
		},
		changeImage(e){
			console.log(e.target.files[0])
			this.client.logo = e.target.files[0]
			let file = e.target.files[0]
			let reader = new FileReader()
			reader.onload = function(e) {
      	return e.target.result
			}
			 reader.readAsDataURL(file);
		},
		changeValue(event){
			if(event.length > 0) {
				const city = this.citiesFromController.filter(city => city.name == event)
				this.city_id = city[0].id
				console.log(this.city_id)
			}
		}
	},
	computed:{
		citiesFromController:{
			get() {
				return this.cities
			}
		}
	},
	created(){
		this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
		console.log(this.token)
		this.getCities()
	},
	components:{
		'v-select':VueSelect,
		AutocompleteLocal
	}
}
</script>

<style>
#allStyles{
	-webkit-tap-highlight-color: transparent;
--blue: #007bff;
--indigo: #6610f2;
--purple: #6f42c1;
--pink: #e83e8c;
--red: #dc3545;
--orange: #fd7e14;
--yellow: #ffc107;
--green: #28a745;
--teal: #20c997;
--cyan: #17a2b8;
--white: #fff;
--gray: #6c757d;
--gray-dark: #343a40;
--primary: #007bff;
--secondary: #6c757d;
--success: #28a745;
--info: #17a2b8;
--warning: #ffc107;
--danger: #dc3545;
--light: #f8f9fa;
--dark: #343a40;
--breakpoint-xs: 0;
--breakpoint-sm: 576px;
--breakpoint-md: 768px;
--breakpoint-lg: 992px;
--breakpoint-xl: 1200px;
--font-family-sans-serif: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
--font-family-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
color: #212529;
text-align: left;
white-space: normal;
cursor: text;
margin: 0;
border: 0;
font-size: 100%;
font: inherit;
vertical-align: baseline;
box-sizing: border-box;
display: flex;
flex-basis: 100%;
flex-grow: 1;
flex-wrap: wrap;
padding: 0 2px;
position: relative;
}
</style>
